<template>
    <v-dialog
    :value="show"
    max-width="500px"
    @input="closeModal">
    <v-card class="px-4 pt-4 pb-2">
      <v-card-title>
        <h2>
          {{ titleName }}
        </h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-layout>
            <v-flex  md5 pr-3>
              <v-text-field 
                v-model="element[method.type]"
                :label="method.type == 'phone' ? 'Teléfono' : 'Email' "
                color="black"
                v-validate="`required${ method.type == 'phone' ? '' : '|email' }`"
                data-vv-name="email"
                :error-messages="errors.collect('email')"
              ></v-text-field>
            </v-flex>
            <v-flex md3 pr-3>
              <v-select
                label="Tipo"
                v-model="element.type"
                :items="items"
                color="black"
                v-validate="'required'"
                data-vv-name="type"
                :error-messages="errors.collect('type')"
              ></v-select>
            </v-flex>
            <v-flex md4>
              <v-select
                label="Estado"
                v-model="element.status"
                :items="itemStatus"
                color="black"
                v-validate="'required'"
                data-vv-name="status"
                :error-messages="errors.collect('status')"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions class="pr-2">
        <v-spacer></v-spacer>
        <v-btn color="black darken-1" flat @click="closeModal">
          Cerrar
        </v-btn>
        <v-btn  flat class="k-orange-linear-text" @click="save" :disabled="sending || formIsInvalid">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import contacDtlMixin from '@/mixins/contactDtl';

  export default {
    inject: ['$validator'],
    props: {
      customer: {
        type: Object,
        required: true,
      },
      show: {
        type: Boolean,
        required: true,
      },
      method: {
        type: Object,
        default() {
          return {
            id: 0,
            type: 'phone',
          };
        },
      },
    },
    mixins: [
      contacDtlMixin,
    ],
    data() {
      return {
        sending: false,
        element: {
          type: '',
          status: '',
        },
        itemsTypeEmail: [
          {
            text: 'Principal',
            value: 'Principal',
          },
        ],
        itemsTypePhone: [
          {
            text: 'Celular',
            value: 'Celular',
          },
          {
            text: 'Fijo',
            value: 'Fijo',
          },
          {
            text: 'Referido',
            value: 'Referido',
          },
        ],
        itemStatus: [
          {
            text: 'Valido',
            value: 'Valido',
          },
          {
            text: 'Invalido',
            value: 'Invalido',
          },
          {
            text: 'Equivocado',
            value: 'Equivocado',
          },
          {
            text: 'Por validar',
            value: 'Por validar',
          },
        ],
      };
    },
    computed: {
      items() {
        return this.method.type === 'phone' ? this.itemsTypePhone : this.itemsTypeEmail;
      },
      titleName() {
        let name;
        if (this.method.id > 0) {
          name = 'Editar ';
        } else {
          name = 'Crear ';
        }
        if (this.method.type === 'email') {
          name += 'email';
        } else {
          name += 'Telefono';
        }
        return name;
      },
      formIsInvalid() {
        return this.element[this.method.type] === '' && this.element.type === '' && this.element.status === '';
      },
    },
    methods: {
      save() {
        this.sending = true;
        this.element.customer_id = this.customer.id;
        if (this.method.id) {
          this.axios.patch(`customer_${this.method.type}s/${this.method.id}`, this.element).then(({ data }) => {
            this.$emit('contact-updated', {
              type: this.method.type,
              value: data,
            });
            this.sending = false;
            this.closeModal();
          }).catch(() => {});
        } else {
          this.axios.post(`customer_${this.method.type}s`, {
            ...this.element,
            origin_id: 3,
          }).then(({ data }) => {
            this.$emit('contact-added', {
              type: this.method.type,
              value: data,
            });
            this.sending = false;
            this.closeModal();
          }).catch(() => {
            this.sending = false;
          });
        }
      },
      closeModal() {
        this.element = {
          type: '',
          status: '',
        };
        this.$emit('close');
      },
    },
    watch: {
      show() {
        if (this.show) {
          if (this.method.id !== 0) {
            this.element = {
              ...this.customer[`customer_${this.method.type}s`].find(item => item.id === this.method.id),
            };
          }
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/customer/EditMethod.vue